import {
  callApiCapNhatThuTu,
  callApiLayDanhSachNhomChucVu,
  callApiLayDanhSachNhomChucVuPaging,
  callApiSuaNhomChucVu,
  callApiTaoNhomChucVu,
  callApiXoaNhomChucVu
} from "@/api/nhom-chuc-vu";
import {
  SUA_NHOM_CHUC_VU_THANH_CONG,
  THEM_MOI_NHOM_CHUC_VU_THANH_CONG,
  XOA_NHOM_CHUC_VU_THANH_CONG
} from "@/constants/message";
import { showMsgOk, showMsgError } from "@/utils/commonUtils";

const layDanhSachNhomChucVu = async ({ commit }, payload) => {
  const response = await callApiLayDanhSachNhomChucVu(payload);
  if (response && response.data.succeeded) {
    commit("LAY_DANH_SACH_NHOM_CHUC_VU_THANH_CONG", response.data.data);
  }
};

const layDanhSachNhomChucVuPaging = async ({ commit }, payload) => {
  const response = await callApiLayDanhSachNhomChucVuPaging(payload);
  if (response && response.data.succeeded) {
    commit("LAY_DANH_SACH_NHOM_CHUC_VU_PAGING_THANH_CONG", response.data.data);
  }
};



const themNhomChucVu = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    callApiTaoNhomChucVu(payload.data).then((res) => {
      resolve(res);
      showMsgOk(THEM_MOI_NHOM_CHUC_VU_THANH_CONG);
      commit("THEM_MOI_NHOM_CHUC_VU_THANH_CONG", response.data.data);
      payload.onSuccess();
    }).catch((err) => {
      reject(err.response);
    })
  })
};

const suaNhomChucVu = async ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaNhomChucVu(payload.data).then((res) => {
      resolve(res);
      showMsgOk(SUA_NHOM_CHUC_VU_THANH_CONG);
      commit("SUA_NHOM_CHUC_VU_THANH_CONG", response.data.data);
      payload.onSuccess();
    }).catch((err) => {
      reject(err.response);
    })
  })
};

// eslint-disable-next-line no-empty-pattern
const xoaNhomChucVu = async (context, payload) => {
  return new Promise((resolve) => {
    callApiXoaNhomChucVu(payload.data).then((res) => {
      showMsgOk(XOA_NHOM_CHUC_VU_THANH_CONG);
      payload.onSuccess();
    }).catch((err) => {
      showMsgError(err.response.data.message);
    })
  })
};
// eslint-disable-next-line no-empty-pattern
const capNhatThuTu = async (context, payload) => {
  const response = await callApiCapNhatThuTu(payload.data);
  if (response && response.data.succeeded) {
    // payload.onSuccess();
  }
};

export default {
  layDanhSachNhomChucVu,
  layDanhSachNhomChucVuPaging,
  themNhomChucVu,
  suaNhomChucVu,
  xoaNhomChucVu,
  capNhatThuTu
};
